import { render, staticRenderFns } from "./morningPaperSet.vue?vue&type=template&id=2cffd953&scoped=true&"
import script from "./morningPaperSet.vue?vue&type=script&lang=js&"
export * from "./morningPaperSet.vue?vue&type=script&lang=js&"
import style0 from "./morningPaperSet.vue?vue&type=style&index=0&id=2cffd953&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffd953",
  null
  
)

export default component.exports